import React from 'react';
import { Plus, Minus, Trash2 } from 'lucide-react';

export const CartItem = ({ item, onUpdateQuantity, onRemove }) => (
  <div className="flex gap-4 bg-gray-50 rounded-lg p-4">
    <div className="w-20 h-20 flex-shrink-0 rounded-md overflow-hidden bg-white">
      <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
    </div>

    <div className="flex-1 min-w-0">
      <h3 className="text-sm font-semibold text-[#001B2A] mb-1 truncate">{item.name}</h3>
      <p className="text-sm font-bold text-[#7B1E2B] mb-2">${item.price.toFixed(2)}</p>

      <div className="flex items-center gap-2">
        <button
          onClick={() => onUpdateQuantity(item.id, item.quantity - 1)}
          data-testid={`qty-decrease-${item.id}`}
          className="p-1 border border-gray-300 rounded hover:bg-white transition-colors"
        >
          <Minus className="h-3 w-3" />
        </button>
        <span className="text-sm font-medium w-8 text-center">{item.quantity}</span>
        <button
          onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
          data-testid={`qty-increase-${item.id}`}
          className="p-1 border border-gray-300 rounded hover:bg-white transition-colors"
        >
          <Plus className="h-3 w-3" />
        </button>
        <button
          onClick={() => onRemove(item.id, item.name)}
          className="ml-auto p-1 text-red-500 hover:bg-red-50 rounded transition-colors"
        >
          <Trash2 className="h-4 w-4" />
        </button>
      </div>
    </div>
  </div>
);
